import React, { lazy, Suspense } from "react"
import { Switch, Route } from "react-router-dom"
import Private from "components/Private"

import Loading from "components/Loading"
import NotFound from "components/NotFound"
import MainContainer from "components/MainContainer"
//
const Vat301 = lazy(() => import("./Vat301"))
const Vat301Approval = lazy(() => import("./Vat301Approval"))
const Vat301Suspensions = lazy(() => import("./Vat301Suspensions"))
//
const CancelEg = lazy(() => import("./CancelEg"))
const Suspensions = lazy(() => import("./Suspensions"))
//
const Vat702 = lazy(() => import("./Vat702"))

function Routes() {
  return (
    <MainContainer>
      <Suspense fallback={<Loading />}>
        <Switch>
          {/* Protected */}
          <Private path="/vat-non-registered" component={Vat301} />
          <Private path="/declaration-approval" component={Vat301Approval} />
          <Private path="/customs-suspensions" component={Vat301Suspensions} />
          <Private path="/cancel-eg" component={CancelEg} />
          <Private path="/suspensions" component={Suspensions} />

          <Private path="/eg-deposit" component={Vat702} />

          {/* NF */}
          <Route component={NotFound} />
        </Switch>
      </Suspense>
    </MainContainer>
  )
}

export default Routes
